import { ESwitcherAssetType } from "./switcher-item.type.enum";

export class BroadcastPresetAudioChannel {
  static readonly MASTER_CHANNEL_NAME = "Master";

  constructor(
    public assetType: ESwitcherAssetType,
    public sourceUid: string,
    public name: string,
    public language: string,
    public pid: number,
    public volumeLevel: number,
    public isVisible: boolean = true,
    public isMuted: boolean = true,
    public isClearedForAir: boolean = false,
    public previewListenMuted: boolean = true,
  ) {}

  public static createNew(
    assetType: ESwitcherAssetType,
    name: string,
    sourceUid: string,
    language: string = "XX",
    pid: number = 1,
    volumeLevel: number = 1.0,
    isVisible: boolean = true,
  ): BroadcastPresetAudioChannel {
    return new BroadcastPresetAudioChannel(
      assetType,
      sourceUid,
      name,
      language,
      pid,
      volumeLevel,
      isVisible,
    );
  }

  public clone(): BroadcastPresetAudioChannel {
    return new BroadcastPresetAudioChannel(
      this.assetType,
      this.sourceUid,
      this.name,
      this.language,
      this.pid,
      this.volumeLevel,
      this.isVisible,
      this.isMuted,
      this.isClearedForAir,
      this.previewListenMuted,
    );
  }
  public get isMaster(): boolean {
    return this.assetType === ESwitcherAssetType.Empty;
  }
  public get isLiveFeed(): boolean {
    return this.assetType === ESwitcherAssetType.LiveFeed;
  }
  public get UniqueIdentifier(): string {
    return `${this.sourceUid}-${this.pid}`;
  }
}
